import { ReactNode } from 'react';
import { useActiveFamily } from '../../context/ActiveFamilyContext';
import { GlobalTimersProvider } from '../../context/GlobalTimersContext';

/**
 * Wrapper que conecta GlobalTimersProvider con el familyId actual
 * Necesario porque el provider necesita acceso al hook useActiveFamily
 */
export function GlobalTimersWrapper({ children }: { children: ReactNode }) {
  const { activeFamily } = useActiveFamily();
  
  return (
    <GlobalTimersProvider familyId={activeFamily?.id || null}>
      {children}
    </GlobalTimersProvider>
  );
}
